import { orderBy, query, where } from 'firebase/firestore';
import { ID } from 'shared/types/id';

import { smartListConverter } from './converters/smart-list';
import { CollectionOptions, getCollection } from './helpers';

export const getSmartListsQuery = async (uid: ID) => {
  const collection = getCollection(CollectionOptions.SmartLists).withConverter(
    smartListConverter,
  );

  return query(
    collection,
    where('roles.all', 'array-contains', uid),
    orderBy('createdAt', 'asc'),
  );
};
